import { cloneElement, useId } from 'react';

function ClipMask({ children, clipPath, className = '' }) {
  const id = `mask_${useId()}`;

  if (Array.isArray(children)) {
    throw new Error('A ClipMask may have only one child element');
  }

  const styleClipPath = `url(#${id})`;
  const clippedChild = cloneElement(children, {
    style: { clipPath: styleClipPath, WebkitClipPath: styleClipPath },
  });

  return (
    <>
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
        aria-hidden="true"
        className={className}
        style={{ pointerEvents: 'none' }}
      >
        <defs>
          <clipPath id={id} clipPathUnits="objectBoundingBox" transform="scale(0.01 0.01)">
            {clipPath}
          </clipPath>
        </defs>
      </svg>
      {clippedChild}
    </>
  );
}

export default ClipMask;
